import { AuthProvider } from './shared/context/AuthContext';
import { BrandingProvider } from './shared/context/BrandingContext';
import { BrandKitProvider } from './shared/context/BrandKitContext';
import { ThemeProvider } from './shared/context/ThemeContext';
import { PracticeProvider } from './shared/context/PracticeContext';
import { LocationProvider } from './shared/context/LocationContext';
import { ImpersonationProvider } from './shared/context/ImpersonationContext';
import { ToastProvider } from './shared/ui/Toast';
import { AppRoutes } from './routes';

export default function App() {
  return (
    <ThemeProvider>
      <BrandingProvider>
        <AuthProvider>
          <ImpersonationProvider>
            <PracticeProvider>
              <LocationProvider>
                <BrandKitProvider>
                  <ToastProvider>
                    <AppRoutes />
                  </ToastProvider>
                </BrandKitProvider>
              </LocationProvider>
            </PracticeProvider>
          </ImpersonationProvider>
        </AuthProvider>
      </BrandingProvider>
    </ThemeProvider>
  );
}
